// AddItemComps/OtherDetails.js
import React, { useEffect, useState } from 'react';
import FileUpload from './FileUpload/FileUpload';

const OtherDetails = ({ onDataChange, initialValues = {} }) => {
    const [name, setName] = useState(initialValues.name || '');
    const [description, setDescription] = useState(initialValues.description || '');


    useEffect(() => {
        setName(initialValues.name || '');
        setDescription(initialValues.description || '');
    }, [initialValues]);

    const handleNameChange = (e) => {
        setName(e.target.value);
        notifyParent();
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
        notifyParent();
    };



    const notifyParent = () => {
        onDataChange({ name, description });
    };

    return (
        <div>
            <h3>Other Details</h3>
            <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={handleNameChange}
            />
            <textarea
                placeholder="Description"
                value={description}
                onChange={handleDescriptionChange}
            ></textarea>
            <FileUpload
                label="Choose Files"
            />
        </div>
    );
};


export default OtherDetails;
